import { render, staticRenderFns } from "./StockArticleReport.vue?vue&type=template&id=c355bcca&scoped=true&"
import script from "./StockArticleReport.vue?vue&type=script&lang=js&"
export * from "./StockArticleReport.vue?vue&type=script&lang=js&"
import style0 from "./StockArticleReport.vue?vue&type=style&index=0&id=c355bcca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c355bcca",
  null
  
)

export default component.exports